
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class MainMenuItem extends Vue {
  @Prop() private title!: string;
  @Prop() private icon!: string;
  @Prop() private to!: string;
}
